import React, { Suspense, lazy } from 'react';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
// Lazy load components for the new flow
const PainPoints = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const SolutionSection = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const ProductMockup = lazy(() => import('./components/ImpactShowcase').then(m => ({
  default: m.ImpactShowcase
})));
const BenefitsSection = lazy(() => import('./components/SuccessStories').then(m => ({
  default: m.SuccessStories
})));
const BonusGrid = lazy(() => import('./components/BonusGrid').then(m => ({
  default: m.BonusGrid
})));
const ImageCarousel = lazy(() => import('./components/ImageCarousel').then(m => ({
  default: m.ImageCarousel
})));
const OfferSection = lazy(() => import('./components/UpsellBox').then(m => ({
  default: m.UpsellBox
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const MetaPixel = lazy(() => import('./components/MetaPixel').then(m => ({
  default: m.MetaPixel
})));
export function App() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    const target = document.getElementById('oferta');
    if (!target) return;
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 2000; // 2 seconds for a slow feel
    let start: number | null = null;
    function step(timestamp: number) {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const percentage = Math.min(progress / duration, 1);
      // Easing function (easeInOutCubic)
      const ease = percentage < 0.5 ? 4 * percentage * percentage * percentage : 1 - Math.pow(-2 * percentage + 2, 3) / 2;
      window.scrollTo(0, startPosition + distance * ease);
      if (progress < duration) {
        window.requestAnimationFrame(step);
      }
    }
    window.requestAnimationFrame(step);
  };
  return <div className="min-h-screen selection:bg-violet-500/30 selection:text-white" data-id="element-0">
      <Suspense fallback={null} data-id="element-1">
        <MetaPixel data-id="element-2" />
      </Suspense>
      <TopBanner data-id="element-3" />

      <main className="flex flex-col" data-id="element-4">
        <HeroSection data-id="element-5" />

        <Suspense fallback={<div className="min-h-[400px]" data-id="element-7" />} data-id="element-6">
          <PainPoints data-id="element-8" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-10" />} data-id="element-9">
          <SolutionSection data-id="element-11" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[500px]" data-id="element-13" />} data-id="element-12">
          <ProductMockup data-id="element-14" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[800px]" data-id="element-16" />} data-id="element-15">
          <BenefitsSection data-id="element-17" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[800px]" data-id="element-19" />} data-id="element-18">
          <BonusGrid data-id="element-20" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[400px]" data-id="element-22" />} data-id="element-21">
          <ImageCarousel data-id="element-23" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[800px]" data-id="element-25" />} data-id="element-24">
          <OfferSection data-id="element-26" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-28" />} data-id="element-27">
          <TestimonialsSection data-id="element-29" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-31" />} data-id="element-30">
          <FAQSection data-id="element-32" />
        </Suspense>

        {/* Final CTA Section */}
        <section className="py-24 px-4 relative overflow-hidden bg-[#3A3158]/40 pt-[0px] pb-[0px]" data-id="element-33">
          <div className="stars-container" data-id="element-34">
            {[...Array(20)].map((_, i) => <div key={i} className="star" style={{
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            width: `${Math.random() * 3}px`,
            height: `${Math.random() * 3}px`,
            '--duration': `${2 + Math.random() * 4}s`
          } as any} data-id="element-35" />)}
          </div>
          <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-36">
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 leading-tight text-[#D9B15F]" data-id="element-37">
              No podés cambiar lo que pasó, pero sí la forma en que eso sigue
              viviendo dentro de vos.
            </h2>
            <p className="text-xl text-[#B99BE8] mb-10 max-w-2xl mx-auto" data-id="element-38">
              Quizás hoy sea el día de dejar de cargar solo con todo eso.
              Regalate este espacio para volver a vos.
            </p>
            <button onClick={scrollToPricing} className="bg-[#D9B15F] text-[#2C2541] font-bold text-xl px-10 py-5 rounded-full shadow-2xl shadow-[#D9B15F]/20 transition-all hover:scale-105 active:scale-95 uppercase tracking-wider" data-id="element-39">
              💜 QUIERO ACCEDER AL KIT EMOCIONAL
            </button>
            <p className="mt-6 text-[#B99BE8]/60 text-sm font-medium" data-id="element-40">
              Acceso inmediato • Pago seguro • Formato digital
            </p>
          </div>
        </section>
      </main>

      <footer className="bg-[#2C2541] py-12 border-t border-[#D9B15F]/10 text-center" data-id="element-41">
        <div className="max-w-7xl mx-auto px-4" data-id="element-42">
          <p className="text-[#B99BE8]/60 text-sm mb-2" data-id="element-43">
            © 2026 Kit Emocional: Lo Que No Sueltas. Todos los derechos
            reservados.
          </p>
          <p className="text-[#B99BE8]/60 text-sm mb-4" data-id="element-44">
            Soporte:{' '}
            <a href="mailto:soportedigitalfactory@gmail.com" className="hover:text-white transition-colors" data-id="element-45">
              soportedigitalfactory@gmail.com
            </a>
          </p>
          <p className="text-[#B99BE8]/40 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-46">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}